import React from "react";
import {sendRequest} from "../../../utils/request";
import Box from "../../layout/Box";
import CheckBox from "../CheckBox";
import {isTrue} from "../../../utils/other";
import ContentLoader from "../../layout/ContentLoader";
import SelectorGrid from "../SelectorGrid/SelectorGrid";
import {ComponentConfigType} from "../../../utils/ComponentConfigType";

class PointOfSaleType extends React.Component<any, any> {

    state = {
        pointofsales: []
    }

    componentDidMount() {
        this.loadPointOfSales();
    }

    loadPointOfSales = () => {
        this.pointofsales = sendRequest({
            option: "componentlist",
            component: "PointOfSale",
            order: {field: "name", direction: "ASC"},
            itemsperpage: 0
        });
        this.pointofsales.then((response) => {
            this.setState({
                isLoading: false,
                pointofsales: response.items
            });
        });
    }

    render() {
        const all = (this.props.value?.length || 0) + "" === "" + this.props.totalRecords && this.props.totalRecords + "" === "" + this.state.pointofsales.length;
        return (
            <Box
                theme="default"
                header="Eladási helyek"
                actions={<CheckBox
                    checked={all}
                    label="Összes"
                    disabled={this.props.loading || this.props.disabled}
                    saveChanges={() => {
                        if (!isTrue(all)) {
                            //console.log(JSON.parse(JSON.stringify(this.state.pointofsales)));
                            //console.log(JSON.parse(JSON.stringify(this.props.value || [])));
                            //console.log(JSON.parse(JSON.stringify([...this.state.pointofsales.filter((pointofsale) => !(this.props.value || []).find((s) => s.id + "" === "" + pointofsale.id))])));
                            this.props.selectorgrid.addNewRows([
                                ...this.state.pointofsales.filter((pointofsale) => !(this.props.value || []).find((s) => s.id + "" === "" + pointofsale.id))
                            ]);
                        } else {
                            this.props.selectorgrid.onItemsRemove([...this.state.pointofsales]);
                        }
                    }}
                />}
            >
                {this.props.loading ? <ContentLoader/> : <div className="row">
                    {this.state.pointofsales.map((pointofsale, idx) => {
                        const checked = !!(this.props.value || []).find((s) => s.id + "" === "" + pointofsale.id);
                        return <div className="col-md-2 col-lg-2 col-xs-6" key={idx}>
                            <div className="form-group">
                                <CheckBox
                                    name="optional"
                                    type="bool"
                                    value="1"
                                    label={pointofsale.name}
                                    checked={checked}
                                    disabled={this.props.loading || this.props.disabled}
                                    saveChanges={(field, value) => {
                                        if (isTrue(value)) {
                                            this.props.selectorgrid.addNewRows([pointofsale]);
                                        } else {
                                            this.props.selectorgrid.onItemRemove(pointofsale);
                                        }
                                    }}
                                />
                            </div>
                        </div>;
                    })}
                </div>}
            </Box>
        );
    }
}

type Props = {
    componentConfig: ComponentConfigType,
    name: string,
    data: object,
    columns?: any,
}

export default React.forwardRef((_props: Required<Props>, ref) => {
    const props = {..._props};
    if (!props.componentConfig?.fielddefs?.[props.name]) {
        return null;
    }
    return (
        <SelectorGrid
            ref={ref}
            {...props}
            columns={{
                "name": {header: 'Megnevezés', width: 2, sortable: true, filterable: true},
                ...(props.columns || {}),
            }}
            pageSize={0}
            listfieldlabel="name"
            type={PointOfSaleType}
        />
    )
});